// src/pages/qr.js
import React, { useRef } from "react";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image"; // ✅ Correct import

export default function Qr() {
  const qrRef = useRef(null);

  const downloadQRCode = async () => {
    try {
      // Convert QR code div to PNG
      const dataUrl = await toPng(qrRef.current);

      // Create a temporary download link
      const link = document.createElement("a");
      link.download = "outstandingworkplaces-qr.png";
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Error downloading QR code:", error);
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        minHeight: "100vh",
        background: "#f8f9fa",
      }}
    >
      <h1>Outstanding Workplaces QR Code</h1>

      {/* QR Code Container */}
      <div
        ref={qrRef}
        style={{
          display: "inline-block",
          background: "#ffffff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <QRCode
          value="https://outstandingworkplaces.co/"
          size={250}
          level="H"
          bgColor="#FFFFFF"
          fgColor="#000000"
        />
      </div>

      <br />
      <br />

      {/* Download Button */}
      <button
        onClick={downloadQRCode}
        style={{
          padding: "12px 24px",
          fontSize: "16px",
          background: "#007bff",
          color: "#ffffff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        Download QR Code
      </button>
    </div>
  );
}